import { Navigate } from "react-router-dom";
import { Cpu } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import HealthDeviceTypes from "@/pages/health/HealthDeviceTypes";

export default function AdminDeviceTypes() {
  const { user } = useAuth();
  if (user && user.role !== "admin") return <Navigate to="/" replace />;

  return (
    <div className="max-w-4xl px-6 md:px-12 py-10 md:py-14" data-testid="admin-device-types-page">
      <p className="text-[11px] uppercase tracking-[0.18em] text-muted-foreground mb-2">Admin</p>
      <h1 className="font-serif text-3xl md:text-4xl text-foreground mb-2 flex items-center gap-3">
        <Cpu className="w-7 h-7 text-muted-foreground" strokeWidth={1.5} /> Device Types
      </h1>
      <p className="text-muted-foreground mb-8 max-w-2xl leading-relaxed">
        Manage the catalogue of health device types available to everyone. Users pick from these when
        adding a device under Health → My Health.
      </p>
      <HealthDeviceTypes />
    </div>
  );
}
